/**
 * Forest Zen Theme
 * Natural green palette for calm and organic feel
 */

export const forestZenTheme = {
  theme_name: 'Forest Zen',
  theme_description: 'Clean modern dashboard with professional green accents',
  vibe: 'Clean & Professional',

  // Colors - Clean dashboard inspired
  primary_color: '#10B981', // Emerald green for primary actions
  secondary_color: '#6B7280', // Gray for secondary elements
  accent_color: '#059669', // Darker green for accents
  background_color: '#FFFFFF', // Pure white background
  surface_color: '#F9FAFB', // Very light gray for cards/surfaces
  text_color: '#111827', // Dark text for readability
  text_secondary: '#6B7280', // Secondary text
  text_muted: '#9CA3AF', // Muted text
  divider_color: '#E5E7EB', // Light dividers

  // Semantic Status Colors - Clean and professional
  success_color: '#10B981', // Emerald green
  error_color: '#EF4444', // Clean red
  warning_color: '#F59E0B', // Amber warning
  info_color: '#3B82F6', // Blue info

  // Typography - Modern and clean
  font_family: "'Inter', 'Helvetica Neue', 'Arial', sans-serif",
  font_size: '14px',
  heading_font_size: '2rem', // Increased from 1.5rem for better readability
  font_weight_normal: '400',
  font_weight_bold: '600',

  // Layout - Clean and minimal
  border_radius: 8,
  spacing_unit: 8,

  // Theme mode
  mode: 'light',

  // Assets
  logo_url: '',
  favicon_url: '',
  // Custom CSS for clean dashboard styling
  custom_css: ``,
  // Status
  is_active: false,
  status: 'inactive',
};

export default forestZenTheme;
